export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-6.8fc90b66.jpg";